// extracted by extract-css-chunks-webpack-plugin
module.exports = {"seller-page-past-section":"seller-page-past-section___OWFJj","header-text-large":"header-text-large___RkvzH","pagination":"pagination___jQTcw","grid":"grid___dmHzQ"};